import type { IconData } from '@stacksjs/iconify-core'

export const dashboardF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M.832 14.565a10 10 0 0 1-.832-4c0-5.523 4.477-10 10-10s10 4.477 10 10a10 10 0 0 1-.832 4zm9.168-9a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-5 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-5-3a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default dashboardF
